<template>
    <div>
      <Navbar />
      <Header/>
      <Content/>
      <Footer/>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/Navbar.vue'
  import Header from '@/components/Contact/Header.vue';
  import Content from '@/components/Contact/Content.vue';
  import Footer from '@/components/Footer.vue';
  export default {
    name: 'SasAdmission',
    components: {
      Navbar,
      Header,
      Content,
      Footer
    }
  }
  </script>
  
  <style scoped>
  
  </style>